import { Box, Container, Typography } from "@mui/material"
import BlockCard from "./BlockCard";
import Block360Card from "./Block360Card";

const BlockSection = ({name,blocks,assessmentId,is360 = false,changeTab,setCurrentBlock,assessment360}) => {

    return (
        <Container maxWidth={"xl"}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"center"} sx={{marginTop:"50px"}}>
                <Typography variant="h4" color="secondary" fontWeight={400} dangerouslySetInnerHTML={{ __html: name }}/>
                <Box width={"60%"} marginTop={"50px"}>
                {
                    is360 && 
                    <>
                        {
                            blocks?.map((b,i)=>(
                                <Block360Card key={i} block={b} assessmentId={assessmentId} changeTab={changeTab} setCurrentBlock={setCurrentBlock}/>
                            ))
                        }
                    </>
                }
                {
                    !is360 &&
                    <>
                        {
                            blocks?.map((b,i)=>(
                                <BlockCard key={i} block={b} assessmentId={assessmentId} assessment360={assessment360}/> 
                            ))
                        }
                    </>
                }
                </Box>
            </Box>
        </Container>
    )
}

export default BlockSection